<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Attendance Admin</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a [routerLink]="[getDashboardRoute()]" href="javascript:void(0);"
              ><i class="ti ti-smart-home"></i
            ></a>
          </li>
          <li class="breadcrumb-item">Employee</li>
          <li class="breadcrumb-item active" aria-current="page">Attendance Admin</li>
        </ol>
      </nav>
    </div>
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap d-none">
      <div class="me-2 mb-2">
        <div class="d-flex align-items-center border bg-white rounded p-1 me-2 icon-list">
          <a
            href="https://avrtechno.com/html/template/attendance-employee.html"
            class="btn btn-icon btn-sm me-1"
            ><i class="ti ti-brand-days-counter"></i
          ></a>
          <a
            href="https://avrtechno.com/html/template/attendance-admin.html"
            class="btn btn-icon btn-sm active bg-primary text-white"
            ><i class="ti ti-calendar-event"></i
          ></a>
        </div>
      </div>
      <div class="me-2 mb-2 d-none">
        <div class="dropdown">
          <a
            href="javascript:void(0);"
            class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
            data-bs-toggle="dropdown"
          >
            <i class="ti ti-file-export me-1"></i>Export
          </a>
          <ul class="dropdown-menu dropdown-menu-end p-3">
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1"
                ><i class="ti ti-file-type-pdf me-1"></i>Export as PDF</a
              >
            </li>
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1"
                ><i class="ti ti-file-type-xls me-1"></i>Export as Excel
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="mb-2 d-none">
        <a
          href="#"
          class="btn btn-primary d-flex align-items-center"
          data-bs-target="#attendance_report"
          data-bs-toggle="modal"
          ><i class="ti ti-file-analytics me-2"></i>Report</a
        >
      </div>
      <div class="ms-2 head-icons d-none">
        <a
          href="javascript:void(0);"
          class=""
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          data-bs-original-title="Collapse"
          id="collapse-header"
        >
          <i class="ti ti-chevrons-up"></i>
        </a>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <div class="card border-0">
    <div class="card-body">
      <div class="row align-items-center mb-4">
        <div class="col-md-5">
          <div class="mb-3 mb-md-0">
            <h4 class="mb-1">Attendance Details</h4>
            <!-- <p>
              Data from the {{ (clockInOutAnalytics$ | async)?.employeeCount }}+ total number of
              employees
            </p> -->
            <p>Data from {{ (clockInOutAnalytics$ | async)?.employeeCount }} employees</p>
          </div>
        </div>
        <div class="col-md-7 d-none">
          <div class="d-flex align-items-center justify-content-md-end">
            <h6>Total Absenties</h6>
            <div class="avatar-list-stacked avatar-group-sm ms-4 d-none">
              <span class="avatar avatar-rounded">
                <img
                  class="border border-white"
                  src="../../../../assets/img/profiles/avatar-02.jpg"
                  alt="img"
                />
              </span>
              <span class="avatar avatar-rounded">
                <img
                  class="border border-white"
                  src="../../../../assets/img/profiles/avatar-03.jpg"
                  alt="img"
                />
              </span>
              <span class="avatar avatar-rounded">
                <img
                  class="border border-white"
                  src="../../../../assets/img/profiles/avatar-05.jpg"
                  alt="img"
                />
              </span>
              <span class="avatar avatar-rounded">
                <img
                  class="border border-white"
                  src="../../../../assets/img/profiles/avatar-06.jpg"
                  alt="img"
                />
              </span>
              <span class="avatar avatar-rounded">
                <img
                  class="border border-white"
                  src="../../../../assets/img/profiles/avatar-07.jpg"
                  alt="img"
                />
              </span>
              <a
                class="avatar bg-primary avatar-rounded text-fixed-white fs-12"
                href="javascript:void(0);"
              >
                +1
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="border rounded">
        <div class="row gx-0">
          <div class="col-md col-sm-4 border-end">
            <div class="p-3">
              <span class="fw-medium mb-1 d-block">Present</span>
              <div class="d-flex align-items-center justify-content-between">
                <h5>{{ (clockInOutAnalytics$ | async)?.totalPresentToday }}</h5> -->
      <!-- <span class="badge badge-success d-inline-flex align-items-center">
                                                    <i class="ti ti-arrow-wave-right-down me-1"></i>
                                                    +1%
                                              </span> -->
      <!-- </div>
            </div>
          </div>
          <div class="col-md col-sm-4 border-end">
            <div class="p-3">
              <span class="fw-medium mb-1 d-block">Late Login</span>
              <div class="d-flex align-items-center justify-content-between">
                <h5>{{ (clockInOutAnalytics$ | async)?.lateLoginsToday }}</h5> -->
      <!-- <span class="badge badge-danger d-inline-flex align-items-center">
                                                    <i class="ti ti-arrow-wave-right-down me-1"></i>
                                                    -1%
                                              </span> -->
      <!-- </div>
            </div>
          </div> -->
      <!-- <div class="col-md col-sm-4 border-end">
            <div class="p-3">
              <span class="fw-medium mb-1 d-block">Uninformed</span>
              <div class="d-flex align-items-center justify-content-between">
                <h5>{{ (clockInOutAnalytics$ | async)?.todayUnplannedLeaves }}</h5> -->
      <!-- <span class="badge badge-danger d-inline-flex align-items-center">
                                                    <i class="ti ti-arrow-wave-right-down me-1"></i>
                                                    -12%
                                              </span> -->
      <!-- </div>
            </div>
          </div> -->
      <!-- <div class="col-md col-sm-4 border-end">
            <div class="p-3">
              <span class="fw-medium mb-1 d-block">On Leave</span>
              <div class="d-flex align-items-center justify-content-between">
                <h5>{{ (clockInOutAnalytics$ | async)?.todayPlannedLeaves }}</h5> -->
      <!-- <span class="badge badge-success d-inline-flex align-items-center">
                                                    <i class="ti ti-arrow-wave-right-down me-1"></i>
                                                    +1%
                                              </span> -->
      <!-- </div>
            </div>
          </div>
          <div class="col-md col-sm-4">
            <div class="p-3">
              <span class="fw-medium mb-1 d-block">Absent</span>
              <div class="d-flex align-items-center justify-content-between">
                <h5>{{ (clockInOutAnalytics$ | async)?.absentToday }}</h5> -->
      <!-- <span class="badge badge-danger d-inline-flex align-items-center">
                                                    <i class="ti ti-arrow-wave-right-down me-1"></i>
                                                    -19%
                                              </span> -->
      <!-- </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="row">
        <!-- Present -->
        <div class="col-xl-3 col-md-6">
          <div class="card card-present">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between">
                <div class="text-start">
                  <p class="mb-1">Present</p>
                  <h4>{{ (clockInOutAnalytics$ | async)?.totalPresentToday }}</h4>
                </div>
                <div class="d-flex">
                  <div class="flex-shrink-0 me-2">
                    <span class="avatar avatar-md d-flex">
                      <i class="ti ti-user-check fs-32"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Late Login -->
        <div class="col-xl-3 col-md-6">
          <div class="card card-late">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between">
                <div class="text-start">
                  <p class="mb-1">Late Login</p>
                  <h4>{{ (clockInOutAnalytics$ | async)?.lateLoginsToday }}</h4>
                </div>
                <div class="d-flex">
                  <div class="flex-shrink-0 me-2">
                    <span class="avatar avatar-md d-flex">
                      <i class="ti ti-clock-exclamation fs-32"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- On Leave -->
        <div class="col-xl-3 col-md-6">
          <div class="card card-leave">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between">
                <div class="text-start">
                  <p class="mb-1">On Leave</p>
                  <h4>{{ (clockInOutAnalytics$ | async)?.todayPlannedLeaves }}</h4>
                </div>
                <div class="d-flex">
                  <div class="flex-shrink-0 me-2">
                    <span class="avatar avatar-md d-flex">
                      <i class="ti ti-calendar-off fs-32"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Absent -->
        <div class="col-xl-3 col-md-6">
          <div class="card card-absent">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between">
                <div class="text-start">
                  <p class="mb-1">Absent</p>
                  <h4>{{ (clockInOutAnalytics$ | async)?.absentToday }}</h4>
                </div>
                <div class="d-flex">
                  <div class="flex-shrink-0 me-2">
                    <span class="avatar avatar-md d-flex">
                      <i class="ti ti-user-x fs-32"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
      <h5>Admin Attendance</h5>
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
        <div class="me-3">
          <select
            data-extension-safe
            class="form-select form-select-sm col-md-1"
            id="entries"
            [(ngModel)]="pageLimit"
            (change)="onPageLimitChange()"
          >
            <!-- <option selected disabled>Show Entries Per Page</option> -->
            <option *ngFor="let limit of [10, 20, 50, 100]" [value]="limit">{{ limit }}</option>
          </select>
        </div>
        <div class="me-3">
          <div class="input-icon position-relative" style="width: 100%; max-width: 120px">
            <span class="input-icon-addon">
              <i class="ti ti-calendar text-gray-9"></i>
            </span>
            <!-- <input
            appTrimInput
            type="text"
            class="form-control date-range bookingrange"
            placeholder="dd/mm/yyyy - dd/mm/yyyy"
          /> -->
            <input
              type="text"
              id="attendanceSingleDate"
              class="form-control attendanceDatePicker"
              placeholder="dd/mm/yyyy"
              readonly
            />
            <!-- <span class="input-icon-addon">
            <i class="ti ti-chevron-down"></i>
          </span> -->
          </div>
        </div>
        <div class="dropdown me-3">
          <select class="form-select" (change)="handleSortChange($event)">
            <option value="" selected>Select Business Entity</option>
            <option
              *ngFor="let business of businessList$ | async"
              [value]="business.id"
              [selected]="(selectedBusinessId$ | async) === business.id"
            >
              {{ business.businessName | capitalize }}
            </option>
          </select>
        </div>

        <div class="dropdown me-3">
          <select class="form-select" (change)="handleStatusChange($event)">
            <option value="" selected>All Status</option>
            <option value="Present">Present</option>
            <option value="Absent">Absent</option>
            <option value="Leave">Leave</option>
            <option value="Late">Late Login</option>
            <option value="Early">Early</option>
            <option value="Holiday">Holiday</option>
            <option value="Weekly Off">Weekly Off</option>
            <!-- <option value="Uninformed">Uninformed</option> -->
          </select>
        </div>
        <div class="form-sort search-box">
          <label>
            <input
              type="search"
              class="form-control"
              placeholder="Search"
              [(ngModel)]="search"
              (input)="onSearchChange()"
          /></label>
        </div>
        <!-- <div class="form-sort">
                                  <label> <input type="search" [(ngModel)]="search" (input)="getTodayAttendance()" class="form-control"
                                      placeholder="Search"></label>
                        
                                </div> -->
      </div>
    </div>
    <div class="card-body p-0">
      <div class="custom-datatable-filter table-responsive">
        <!-- <div *ngIf="isAttendanceLoading" class="text-center py-4"> -->
        <!-- <div class="spinner-border" role="status" style="color: #f26522">
            <span class="visually-hidden">Loading...</span>
          </div> -->
        <!-- <div class="attendance-image-loader" role="status">
            <img src="../../../../assets/img/logo-small.webp" alt="Loading..." />
            <span class="visually-hidden">Loading...</span>
          </div>
        </div> -->
        <app-loader *ngIf="isAttendanceLoading"></app-loader>
        <ng-container *ngIf="!isAttendanceLoading">
          <ng-container *ngIf="employeeClockInOut$ | async as employeeClockInOut">
            <table class="table datatable" *ngIf="employeeClockInOut.length > 0; else noRecords">
              <thead class="thead-light">
                <tr>
                  <!-- <th class="no-sort">
                                              <div class="form-check form-check-md">
                                                    <input class="form-check-input" type="checkbox" id="select-all">
                                              </div>
                                        </th> -->
                  <th>Employee</th>
                  <th>Start Time</th>
                  <th>End Time</th>
                  <th>Duration</th>
                  <th>Status</th>
                  <th>Business</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let clock of employeeClockInOut">
                  <!-- <td>
                                              <div class="form-check form-check-md">
                                                    <input class="form-check-input" type="checkbox">
                                              </div>
                                        </td> -->
                  <!-- Employee -->
                  <td>
                    <div class="d-flex align-items-center file-name-icon">
                      <a href="javascript:void(0);" class="avatar flex-shrink-0">
                        <!-- If avatar exists, show image -->
                        <img
                          *ngIf="clock.user.picture; else noAvatar"
                          [src]="apiEndpoint + '/uploads/' + clock.user.picture"
                          class="rounded-circle border border-2"
                          alt="img"
                          style="width: 40px; height: 40px"
                          (error)="clock.user.picture = null"
                        />

                        <!-- Fallback: first letter of user name -->
                        <ng-template #noAvatar>
                          <span
                            class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold border border-2"
                            style="width: 40px; height: 40px"
                          >
                            {{ clock.user.firstName.charAt(0) }}{{ clock.user.lastName.charAt(0) }}
                          </span>
                        </ng-template>
                      </a>
                      <div class="ms-2">
                        <h6 class="fw-medium">
                          <a [routerLink]="['/hrm/employee', clock.userId]">
                            {{ clock.user.firstName | capitalize }}
                            {{ clock.user.lastName | capitalize }}</a
                          >
                        </h6>
                        <span class="fs-12 fw-normal"> </span>
                      </div>
                    </div>
                  </td>
                  <!-- <td> -->
                  <!-- {{ clock.clockIn ? getFormatedTime(clock.clockIn) : '-' }} -->
                  <!-- </td> -->
                  <!-- Start Time -->
                  <td>
                    {{
                      clock['workStatuses']?.includes('Holiday') ||
                      clock['workStatuses']?.includes('Weekly Off') ||
                      clock['workStatuses']?.includes('Leave') ||
                      clock['workStatuses']?.includes('Leave First Half') ||
                      clock['workStatuses']?.includes('Leave Second Half')
                        ? '-'
                        : clock.clockIn
                          ? getFormatedTime(clock.clockIn)
                          : '-'
                    }}
                  </td>

                  <!-- <td> -->
                  <!-- {{ clock.clockOut ? getFormatedTime(clock.clockOut) : '-' }} -->
                  <!-- </td> -->

                  <!-- <td>
                  {{
                    clock['workStatuses']?.includes('Holiday') ||
                    clock['workStatuses']?.includes('Leave') ||
                    clock['workStatuses']?.includes('Leave First Half') ||
                    clock['workStatuses']?.includes('Leave Second Half')
                      ? '-'
                      : clock.clockOut
                        ? getFormatedTime(clock.clockOut)
                        : '-'
                  }}
                </td> -->

                  <!-- End Time -->
                  <td>
                    {{
                      clock['workStatuses']?.includes('Holiday') ||
                      clock['workStatuses']?.includes('Weekly Off') ||
                      clock['workStatuses']?.includes('Leave') ||
                      clock['workStatuses']?.includes('Leave First Half') ||
                      clock['workStatuses']?.includes('Leave Second Half')
                        ? '-'
                        : clock.workStatus === 'ClockIn' || clock.workStatus === 'Clock In/Out'
                          ? '-'
                          : clock.clockOut
                            ? getFormatedTime(clock.clockOut)
                            : '-'
                    }}
                  </td>

                  <!-- <td> -->
                  <!-- {{ clock.workHour || '0h 0m' }} -->
                  <!-- {{
                    clock.workStatus === 'Absent' ||
                    clock.workStatus === 'Absent First Half' ||
                    clock.workStatus === 'Absent Second Half'
                      ? '-'
                      : clock.workHour || '0h 0m'
                  }} -->
                  <!-- {{ clock.workHour ? clock.workHour : '-' }} -->
                  <!-- </td> -->

                  <!-- <td>
                  {{
                    clock['workStatuses']?.includes('Holiday') ||
                    clock['workStatuses']?.includes('Leave') ||
                    clock['workStatuses']?.includes('Leave First Half') ||
                    clock['workStatuses']?.includes('Leave Second Half')
                      ? '-'
                      : clock.workHour
                        ? clock.workHour
                        : '-'
                  }}
                </td> -->

                  <!-- Duration -->
                  <td>
                    <!-- {{
                      clock['workStatuses']?.includes('Holiday') ||
                      clock['workStatuses']?.includes('Weekly Off') ||
                      clock['workStatuses']?.includes('Leave') ||
                      clock['workStatuses']?.includes('Leave First Half') ||
                      clock['workStatuses']?.includes('Leave Second Half')
                        ? '-'
                        : clock['lateLogin']
                          ? clock['lateLogin']
                          : clock['earlyLogin']
                            ? clock['earlyLogin']
                            : clock['workHour']
                              ? clock['workHour']
                              : '-'
                    }} -->

                    {{
                      clock['workStatuses']?.includes('Holiday') ||
                      clock['workStatuses']?.includes('Weekly Off') ||
                      clock['workStatuses']?.includes('Leave') ||
                      clock['workStatuses']?.includes('Leave First Half') ||
                      clock['workStatuses']?.includes('Leave Second Half')
                        ? '-'
                        : clock['workHour']
                          ? clock['workHour']
                          : clock['lateLogin']
                            ? clock['lateLogin']
                            : clock['earlyLogin']
                              ? clock['earlyLogin']
                              : '-'
                    }}
                  </td>
                  <!-- <td> -->
                  <!-- Show this when NOT late -->
                  <!-- <span
                    *ngIf="clock.workStatus !== 'Late'"
                    class="badge badge-success-transparent d-inline-flex align-items-center"
                  >
                   
                    {{ clock.workStatus }}
                  </span> -->

                  <!-- Show this ONLY when Late -->
                  <!-- <span *ngIf="clock.workStatus === 'Late'" class="badge badge-danger ms-1">
                   
                    {{ clock.workStatus }}
                  </span> -->
                  <!-- </td> -->
                  <!-- <td>
                  <ng-container *ngFor="let status of clock['workStatuses']">
                    <span
                      class="badge d-inline-flex align-items-center me-2"
                      [ngStyle]="{
                        'background-color': getStatusColor(status),
                        color:
                          getStatusColor(status) === '#FF5252' ||
                          getStatusColor(status) === '#4ECDC4' ||
                          getStatusColor(status) === '#B39DDB'
                            ? '#fff'
                            : '#000'
                      }"
                    >-->
                  <!-- -->
                  <!-- {{ clock.workStatus }} -->
                  <!--    {{ status }}
                    </span>
                  </ng-container>
                </td> -->

                  <td class="status-cell">
                    <div class="status-wrap">
                      <!-- <ng-container *ngFor="let status of clock['workStatuses']"> -->
                      <!-- <ng-container *ngFor="let status of clock.workStatus">
                      <span
                        class="badge status-badge"
                        [ngStyle]="{
                          'background-color': getStatusColor(status),
                          color:
                            getStatusColor(status) === '#FF5252' ||
                            getStatusColor(status) === '#4ECDC4' ||
                            getStatusColor(status) === '#B39DDB'
                              ? '#fff'
                              : '#000'
                        }"
                      >
                        {{ status }}
                      </span>
                    </ng-container> -->
                      <ng-container *ngFor="let status of clock['workStatuses']">
                        <span
                          class="badge status-badge"
                          [ngStyle]="{
                            'background-color': getStatusColor(status),
                            color:
                              getStatusColor(status) === '#FF5252' ||
                              getStatusColor(status) === '#4ECDC4' ||
                              getStatusColor(status) === '#B39DDB'
                                ? '#fff'
                                : '#000'
                          }"
                        >
                          {{ status }}
                        </span>
                      </ng-container>
                    </div>
                  </td>

                  <td>{{ clock.user.business.businessName }}</td>

                  <td>
                    <div class="action-icon d-inline-flex">
                      <a
                        [routerLink]="[eps.attendance.employeeAttendancePath, clock.userId]"
                        [queryParams]="{ date: selectedDateForNav }"
                        class="me-2"
                        ><i class="ti ti-eye"></i
                      ></a>
                      <a
                        [routerLink]="[eps.attendance.calanderPath]"
                        [queryParams]="{
                          userId: clock.userId,
                          businessId: clock.user.businessId,
                          date: selectedDateForNav
                        }"
                        class="me-2"
                      >
                        <i class="ti ti-calendar-event"></i>
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </ng-container>
        </ng-container>

        <ng-template #noRecords>
          <div class="text-center">Record not available</div>
        </ng-template>
      </div>
    </div>

    <!-- pagination -->
    <ng-container *ngIf="!isAttendanceLoading">
      <ng-container *ngIf="employeeClockInOut$ | async as employeeClockInOut">
        <div
          class="d-flex align-items-center justify-content-between ms-2"
          *ngIf="employeeClockInOut && employeeClockInOut.length > 0"
        >
          <div>
            <!-- Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of
          {{ totalCount }} entries -->
            Showing
            {{ totalCount === 0 ? 0 : (currentPage - 1) * pageLimit + 1 }}
            to
            {{ totalCount === 0 ? 0 : pageLastRecord }}
            of
            {{ totalCount }}
          </div>
          <div class="has-text-centered mt-3">
            <app-pagination
              [currentPage]="currentPage"
              [pageSize]="pageLimit"
              [totalRows]="totalCount"
              (pageChange)="onPageChange($event)"
            ></app-pagination>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>

<ng-template #addBusinessModal let-modal>
  <!-- <div class="modal custom-modal fade" id="attendance_info" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content"> -->
  <div class="modal-header">
    <h5 class="modal-title">Attendance Info</h5>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-6">
        <div class="card punch-status">
          <div class="card-body">
            <h5 class="card-title">
              Timesheet
              <!--<small class="text-muted">{{
                employeeClockInOut[0].clockIn | date: 'd MMMM yyyy'
              }}</small>-->
            </h5>
            <div class="punch-det">
              <h6>Punch In at</h6>
              <!-- <p>Wed, 11th Mar 2019 10.00 AM</p> -->
              <!--<p>{{ employeeClockInOut[0].clockIn | date: 'EEE, MMM dd, yyyy, hh:mm a' }}</p>-->
            </div>
            <div class="punch-info">
              <div class="punch-hours">
                <!--<span>{{ totalWorkHours }} hrs</span>-->
              </div>
            </div>
            <div class="punch-det">
              <h6>Punch Out at</h6>
              <p>
                <!--{{
                  employeeClockInOut[employeeClockInOut.length - 1].clockOut
                    | date: 'EEE, MMM dd, yyyy, hh:mm a'
                }}-->
              </p>
            </div>
            <div class="statistics d-none">
              <div class="row">
                <div class="col-md-6 col-6 text-center">
                  <div class="stats-box">
                    <p>Break</p>
                    <h6>1.21 hrs</h6>
                  </div>
                </div>
                <div class="col-md-6 col-6 text-center">
                  <div class="stats-box">
                    <p>Overtime</p>
                    <h6>3 hrs</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card recent-activity">
          <div class="card-body">
            <h5 class="card-title">Activity</h5>
            <ul class="res-activity-list">
              <div *ngFor="let clockinout of employeeClockInOut$ | async">
                <li>
                  <p class="mb-0">Punch In at</p>
                  <p class="res-activity-time">
                    <i class="fa-regular fa-clock"></i>
                    <!-- 10.00 AM. -->
                    {{ getFormatedTime(clockinout.clockIn) }}
                  </p>
                </li>
                <li>
                  <p class="mb-0">Punch Out at</p>
                  <p class="res-activity-time">
                    <i class="fa-regular fa-clock"></i>
                    <!-- 11.00 AM. -->
                    {{ getFormatedTime(clockinout.clockOut) }}
                  </p>
                </li>
              </div>
              <!-- <li>
                                              <p class="mb-0">Punch In at</p>
                                              <p class="res-activity-time">
                                                    <i class="fa-regular fa-clock"></i>
                                                    11.15 AM.
                                              </p>
                                        </li>
                                        <li>
                                              <p class="mb-0">Punch Out at</p>
                                              <p class="res-activity-time">
                                                    <i class="fa-regular fa-clock"></i>
                                                    1.30 PM.
                                              </p>
                                        </li>
                                        <li>
                                              <p class="mb-0">Punch In at</p>
                                              <p class="res-activity-time">
                                                    <i class="fa-regular fa-clock"></i>
                                                    2.00 PM.
                                              </p>
                                        </li>
                                        <li>
                                              <p class="mb-0">Punch Out at</p>
                                              <p class="res-activity-time">
                                                    <i class="fa-regular fa-clock"></i>
                                                    7.30 PM.
                                              </p>
                                        </li> -->
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </div>
    </div>
</div> -->
</ng-template>
